/**
 * A few studio-aware example prompts surfaced on the empty canvas so a
 * first-time user has a one-click way to see the lab produce something.
 * Clicking a chip seeds the Generate panel's prompt (via agentResultStore)
 * and switches to the Generate operation.
 *
 * Keyed by studioId; falls back to a generic creative set.
 */
const EXAMPLES_BY_STUDIO: Record<string, string[]> = {
  generic: [
    'A serene mountain lake at golden hour, mirror reflection',
    'A cozy reading nook with warm lamplight and a sleeping cat',
    'A futuristic city skyline under a neon aurora',
  ],
  fashion: [
    'Editorial portrait of a model in a flowing ankara gown, studio lighting',
    'Full-length streetwear look, urban backdrop, three-quarter pose',
    'Haute-couture silk dress on a runway, dramatic side lighting',
  ],
  'product-photography': [
    'A glass perfume bottle on polished marble, soft studio light',
    'Wireless headphones floating on a clean gradient background',
    'A gourmet burger on a wooden board, warm golden-hour light',
  ],
};

const DEFAULT_EXAMPLES = EXAMPLES_BY_STUDIO.generic;

export function examplePromptsForStudio(studioId: string | undefined): string[] {
  if (!studioId) return DEFAULT_EXAMPLES;
  return EXAMPLES_BY_STUDIO[studioId] ?? DEFAULT_EXAMPLES;
}
